import { Button } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useTranslation } from "react-i18next";
import { AlertResponseEnum } from "./AlertResponse";
import styles from "./Modal.module.css";
import { StyledDialog } from "./StyledDialog";

// properties that is to be added
// isModalOpen - Modal open or not
// setIsModalOpen - to change the state ofn the modal
// businessProcess - Additional business functionalities , non mandatory
// modalWidth - width of the screen , if not provided it is sm
// title - Title of the screen , if not provided it is "Alert"
// type - Can be Ok , Ok Cancel or Delete Cancel

function WidgetChangeAlertModal(props) {
  const { t } = useTranslation("common");

  const menuCloser = () => {
    document.getElementById("menubar").style.left = "-400px";
    document.querySelector(".close_overlay").style.display = "none";
  };

  const handleAction = (event, reason, response) => {
    event.stopPropagation();
    // when we have clicked outside the modal the screen should not close
    if (reason && reason === "backdropClick") return;

    // call the additional methods also if present
    if (props.onClose) {
      props.onClose(response, props.data);
    }
    // set close state as false , to close the dialog
    props.setIsModalOpen(false);

    //close side bar for the devices having width less than 992px (tablet or smaller than that)
    if (window.innerWidth <= 992) {
      menuCloser();
    }
  };

  // if the modal width is not provided sm is taken as the width else modal width is returned as width
  // widths that can be provided are xs, sm, md, lg , xl
  const getModalWidth = () => {
    if (props.modalWidth) {
      return props.modalWidth;
    } else {
      return "sm";
    }
  };

  return (
    <>
      {/* Dialog window which has open property to indicate if screen is open or not,
            on close function , actions to be handled on close
       */}
      <StyledDialog
        open={props.isModalOpen}
        onClose={(event) => handleAction(event, "backdropClick")}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={getModalWidth}
      >
        {/* Title will be provided in props , if not provided "Alert" will be shown as the title
         */}
        <DialogTitle className={styles.modaltitle} id="alert-dialog-title">
          {props.title ? t(props.title) : t("modal.alertModalTitle")}
        </DialogTitle>

        {/* All the content of the dialog will be displayed here */}
        <DialogContent className={styles.modalcontent} sx={{ mt: 2 }}>
          <>
            Want to save your changes in{" "}
            <b>{props.currentWidget?.widgetName || "this widget"}</b>?
          </>
        </DialogContent>

        {/* All the actions ok , cancel and delete will be taken here
         */}
        <DialogActions className={styles.modalfooter}>
          <Button
            className="btn shadow-none cancel_btn cursor_pointer"
            onClick={(event) =>
              handleAction(event, "click", AlertResponseEnum.Cancel)
            }
          >
            {t("alertAction.cancel")}
          </Button>
          <Button
            className="btn shadow-none cancel_btn cursor_pointer"
            onClick={(event) =>
              handleAction(event, "click", AlertResponseEnum.DontSave)
            }
          >
            {t("alertAction.dontSave")}
          </Button>
          <Button
            className="btn shadow-none ok_btn cursor_pointer"
            onClick={(event) =>
              handleAction(event, "click", AlertResponseEnum.Save)
            }
          >
            {t("alertAction.save")}
          </Button>
        </DialogActions>
      </StyledDialog>
    </>
  );
}

export default WidgetChangeAlertModal;
